import { FormEvent, useState } from "react";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import {
  registrationInfoStore,
  useRegistration,
} from "../../libs/registration/registration.hook";
import { AppForm } from "../form/styles/app-form";
import { BackButton } from "../form/styles/back-button";
import { CtaButton } from "../form/styles/cta-button";
import { SingleInput } from "../form/styles/single-input";

export const ContactInfoComp = (props: {
  setStep: (step: RegistrationSteps) => void;
}) => {
  const [firstName, setFirstName] = useState(
    registrationInfoStore?.firstName || ""
  );
  const [lastName, setLastName] = useState(
    registrationInfoStore?.lastName || ""
  );
  const [phone, setPhone] = useState(registrationInfoStore?.phone || "");
  const { setRegistrationInfo, writeRegistrationInfo } = useRegistration();

  const canProceed = firstName && lastName && phone;

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (firstName && lastName && phone) {
      writeRegistrationInfo();
      props.setStep(RegistrationSteps.StudentInfo);
    }
  };

  const onBlur = () => {
    setRegistrationInfo({ firstName, lastName, phone });
  };

  const onBack = (event: FormEvent) => {
    event.preventDefault();
    props.setStep(RegistrationSteps.Email);
  };

  return (
    <AppForm onSubmit={onSubmit}>
      <SingleInput
        onChange={(event: any) => setFirstName(event.target.value)}
        onBlur={onBlur}
        value={firstName}
        placeholder="First name"
      />
      <SingleInput
        onChange={(event: any) => setLastName(event.target.value)}
        onBlur={onBlur}
        value={lastName}
        placeholder="Last name"
      />
      <SingleInput
        onChange={(event: any) => setPhone(event.target.value)}
        onBlur={onBlur}
        value={phone}
        placeholder="Phone"
      />
      <div>
        <BackButton onClick={onBack}>Back</BackButton>
        <CtaButton disabled={!canProceed}>Next</CtaButton>
      </div>
    </AppForm>
  );
};
